import { StyledSummary } from './StudentSummary.styled';
import { Button, Progress } from 'antd';
import Colors from '@/constants/Colors';
import useStudentSummary from './useStudentSummary.hook';
import QuestionCard from '../QuestionCard/QuestionCard';
import { PlayCircleFilled } from '@ant-design/icons';

export default function StudentSummary({ answers, screens, restartGame }) {
  const { state } = useStudentSummary({ answers, screens });

  return (
    <StyledSummary>
      <div className="results">
        <div className="results-header">
          <div className="title-and-number">
            <h3>
              <span>Your result</span>
            </h3>
            <Progress
              className="progress-bar"
              percent={state.progress}
              success={{
                percent: state.correct,
                strokeColor: Colors.success,
              }}
              status="normal"
              strokeColor={Colors.red}
              format={() => `${state.correct}/${state.progress}%`}
            />
          </div>
        </div>

        {state.failedQuestions.length > 0 ? (
          <>
            <h3>Let's Review!</h3>
            <h5>
              Score: {state.correct}/{state.progress}%
            </h5>
            <p>Check out the answers that need a bit more practice.</p>
            <p>
              <span>Ready to try again? Click </span>
              <Button size="small" onClick={restartGame}>
                <span className="text">Play again</span>
                <PlayCircleFilled />
              </Button>
              <span> to improve your score!</span>
            </p>
            <div className="questions-container">
              <div className="questions">
                {state.failedQuestions.map((question) => (
                  <QuestionCard key={question.id} question={question} />
                ))}
              </div>
            </div>
          </>
        ) : (
          <>
            <h4>¡Fantástico!</h4>
            <h5>Score: 100/100%</h5>
            <p>You did it! Every answer was just right!</p>
            <h3>¡Eres increíble!</h3>
          </>
        )}
      </div>
    </StyledSummary>
  );
}
